module.exports = __webpack_public_path__ + "img/infrastructure.6fb07105.svg";